// extracted by mini-css-extract-plugin
export default {"page":"rda-z","cartModal":"sda-z","checkout":"tda-z","placeholder":"uda-z","account":"vda-z"};